import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import React, { FC, useState } from 'react';
import { removeUserFromNotificationDefinitions } from 'state/ducks/notifications/operations';
import { localized } from 'state/i18n';
import { Spinner } from 'view/components/spinner/spinner';

type UnsubscribeStatus = 'idle' | 'spinning' | 'success' | 'cancelled';

export const UnsubscribeNotifications: FC = () => {
	const [status, setStatus] = useState<UnsubscribeStatus>('idle');

	const handleConfirm = async () => {
		setStatus('spinning');
		try {
			let path = window.location.pathname;
			let encryptedString = path.substring(27);
			await removeUserFromNotificationDefinitions(encryptedString);
			setStatus('success');
		} catch (error) {
			console.error('Failed to unsubscribe:', error);
			setStatus('idle');
		}
	};

	const handleCancel = () => {
		setStatus('cancelled');
	};

	return (
		<div className="ie">
			<div className="ie-container">
				{status === 'idle' && (
					<Card title={localized('ConfirmUnsubscribe')}>
						<p>{localized('AreYouSureYouWantToUnsubscribe')}</p>
						<div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
							<Button label={localized('Yes')} onClick={handleConfirm} autoFocus />
							<Button label={localized('No')} onClick={handleCancel} className="p-button-text" />
						</div>
					</Card>
				)}

				{status === 'spinning' && (
					<Card title={localized('UnsubscribingNotification')}>
						<Spinner
							shouldOverlay={false}
							spinnerSize="spinner-container-1-4th-size"
							useMarginsForCorrectingCentering={false}
						/>
					</Card>
				)}

				{status === 'success' && <Card title={localized('SuccesfullUnsubscribe')}></Card>}

				{status === 'cancelled' && (
					<Card title={localized('UnsubscribeCancelled')}>
						<p>{localized('StillSubscribed')}</p>
					</Card>
				)}
			</div>
		</div>
	);
};
